module.exports = __webpack_public_path__ + "img/delivery_green.e0d682d8.png";